import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [], // Start empty; hydrate later on the client
};

const inventorySlice = createSlice({
  name: "inventory",
  initialState,
  reducers: {
   setInventory: (state, action) => {
      state.items = action.payload;
    },
    addItem: (state, action) => {
      const { id, name, itemCft } = action.payload;
      console.log("Reducer received:", action.payload); // This will now log
      
      // Use defaults if values are missing
      const itemName = name || 'Unknown';
      const cft = itemCft || 0;

      const existingItem = state.items.find(item => item.id === id);
      if (existingItem) {
        existingItem.count += 1;
      } else {
        state.items.push({ 
          id, 
          name: itemName, 
          itemCft: cft, 
          count: 1 
        });
      }
    },
    removeItem: (state, action) => {
      // FIX: Use id instead of itemId
      const { id } = action.payload;

      if (!id) {
        throw new Error("Item ID is required to remove an item.");
      }

      const existingItem = state.items.find((item) => item.id === id);
      if (existingItem) {
        if (existingItem.count > 1) {
          existingItem.count -= 1;
        } else {
          state.items = state.items.filter((item) => item.id !== id);
        }
      }
    },
    updateQuantity: (state, action) => {
      const { id, quantity } = action.payload;

      if (quantity < 0) {
        throw new Error("Quantity cannot be negative.");
      }

      const itemIndex = state.items.findIndex((item) => item.id === id);
      if (itemIndex !== -1) {
        if (quantity > 0) {
          state.items[itemIndex].count = quantity;
        } else {
          state.items.splice(itemIndex, 1);
        }
      }
    },
    resetInventory: (state) => {
      state.items = [];
    }
  },
});

export const { addItem, removeItem, updateQuantity, setInventory } = inventorySlice.actions;
export default inventorySlice.reducer;
